export const nameOverrides: Record<string, string> = {
    new_york_city: 'New York City, New York, USA',
    beijing: 'Beijing, Kina',
    ibiza: 'Ibiza by, Spania',
    las_palmas: 'Las Palmas, Gran Canaria, Spania',
    phuket_town: 'Phuket by, Thailand',
};
